import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectCreateFilters = createSelector(
  [(store: RootState) => store.massNotification.createFilters],
  (data) => data
);
